import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Select } from 'antd'
import { Tooltip } from 'antd'
import { get, debounce, isEmpty } from 'lodash'

const Option = Select.Option

function CustomDebounceSelect(props) {
  const { value, display, onChange, placeholder, data, keyAtr, valueAtr, fetch, fetching, ref, setSelected } = props

  const sliceValue = 100
  const debounceTime = 400
  const [cashedData, setCashedData] = useState(data.slice(0, sliceValue))
  const [lastFetchId, setLastFetchId] = useState(0)

  useEffect(() => {
    if (!isEmpty(value) && !!setSelected) {
      const item = data.find((a) => a[keyAtr] === value)
      setSelected(item)
    }

    return () => {}
  }, [value, data, data.length])

  useEffect(() => {
    if (value) {
      const searchResults = data.filter((f) => (f[keyAtr] || '').toLowerCase().indexOf(value.toLowerCase()) >= 0)
      const topFoundWithPadding = [...searchResults, ...data.slice(0, sliceValue)].slice(0, sliceValue)
      setCashedData(topFoundWithPadding)
    } else {
      setCashedData(data.slice(0, sliceValue))
    }
  }, [data, value])

  function fetchDate(value) {
    console.log('fetching user', value)
    setLastFetchId(lastFetchId + 1)

    //slice(0, 100) is to get top 100 results
    const filteredDate = data
      .filter((f) => get(f, valueAtr, '').toLowerCase().indexOf(value.toLowerCase()) >= 0)
      .slice(0, sliceValue)
    setCashedData(filteredDate)
  }

  return (
    <Tooltip
      placement="top"
      mouseEnterDelay={1}
      mouseLeaveDelay={0.5}
      overlayStyle={{ background: 'white' }}
      title={
        <Button
          size={props.size}
          style={{ backgroundColor: 'Transparent', color: 'white' }}
          icon="retweet"
          onClick={fetch}>
          Refresh dropdown
        </Button>
      }
      trigger="hover">
      <Select
        data-testid={props['data-testid']}
        style={{ width: '100%' }}
        value={value}
        display={display}
        showSearch
        ref={ref}
        allowClear={true}
        onChange={onChange}
        placeholder={placeholder || 'Select an option'}
        filterOption={false}
        onSearch={debounce(fetchDate, debounceTime)}
        {...props}>
        {props.children ||
          cashedData.map((c) => (
            <Option data-testid={get(c, keyAtr)} key={get(c, keyAtr)} value={get(c, keyAtr)} title={get(c, valueAtr)}>
              {get(c, valueAtr) || get(c, keyAtr)}
            </Option>
          ))}
      </Select>
    </Tooltip>
  )
}

CustomDebounceSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  data: PropTypes.array.isRequired,
  keyAtr: PropTypes.string,
  valueAtr: PropTypes.string,
}

CustomDebounceSelect.defaultProps = { keyAtr: 'key', valueAtr: 'value' }
export default CustomDebounceSelect
